const CHECKOUT_SOURCES = new Set(["HostedCheckout", "EcommerceCheckout"]);

/** Keep hosted and ecommerce bank returns on the same checkout lifecycle. */
export function getCheckoutCallbackPath({
  source,
  checkoutId,
  paymentId,
  failed = false,
}) {
  if (!CHECKOUT_SOURCES.has(source) || !checkoutId) return null;

  if (failed) {
    return `/checkout/${checkoutId}?error=bankauth`;
  }

  return `/checkout/${checkoutId}/processing?p-id=${paymentId}&t=openbanking`;
}
